import {Coefficient} from "./coefficient";
import {EnumCorridorColor} from "./enum-corridor-color";
import {MultiServiceBoost} from "./multi-service-boost";

// Utilisée quand la durée de contrat par défaut du pays/rôle/service n'est pas paramétrée
const FALLBACK_DEFAULT_CONTRACT_DURATION = 48;

export class Pct {
    readonly pct: number;
    readonly deltaPctWithOneMoreService: number;

    constructor(
        coefficient: Coefficient,
        multiServiceBoost: MultiServiceBoost,
        quoteServiceAppliedPriceColor: EnumCorridorColor,
        quoteServiceMonthlyAmount: number,
        nonNegociableArticlesMonthlyAmount: number,
        negociableArticlesMonthlyAmount: number,
        quoteServiceContractDuration: number,
        cmcUniqueReference: boolean,
        nonNegociableArticleColor: string,
        uniqueReferenceCoefficient: number,
        boost: number,
        boostWithOneMoreService: number,
        defaultContractDuration?: number
    ) {
        if (
            coefficient == undefined ||
            !(<any>Object)
                .values(EnumCorridorColor)
                .includes(quoteServiceAppliedPriceColor) ||
            quoteServiceMonthlyAmount == undefined ||
            negociableArticlesMonthlyAmount == undefined ||
            nonNegociableArticlesMonthlyAmount == undefined ||
            cmcUniqueReference == undefined || nonNegociableArticleColor == undefined || uniqueReferenceCoefficient == undefined ||
            quoteServiceContractDuration == undefined
        ) {
            this.pct = 0.0;
            this.deltaPctWithOneMoreService = 0;
            return;
        }

        const colorCoefForNegociableArticles = coefficient.getCoefFromColor(quoteServiceAppliedPriceColor);
        const colorCoefForNonNegociableArticles = coefficient.getCoefFromColor(nonNegociableArticleColor);

        if (cmcUniqueReference) {
            this.pct = quoteServiceMonthlyAmount * uniqueReferenceCoefficient;
        } else {
            const pctForNegociableArticles = negociableArticlesMonthlyAmount * colorCoefForNegociableArticles;
            const pctForNonNegociableArticles = nonNegociableArticlesMonthlyAmount * colorCoefForNonNegociableArticles;
            this.pct = pctForNegociableArticles + pctForNonNegociableArticles;
        }

        const contractDurationBase = defaultContractDuration > 0 ? defaultContractDuration : FALLBACK_DEFAULT_CONTRACT_DURATION;
        this.pct = this.pct * (quoteServiceContractDuration / contractDurationBase);

        if (coefficient.monthlyAmount !== null && (coefficient.monthlyAmount - quoteServiceMonthlyAmount) < 0) {
            const plafond = coefficient.monthlyAmount / quoteServiceMonthlyAmount;
            this.pct = this.pct * plafond;
        }
        if (!!multiServiceBoost && multiServiceBoost.isImpacted && quoteServiceMonthlyAmount >= multiServiceBoost.minCaForImpact){
            const pctWithoutBoost=this.pct;
            this.pct = this.calculateBoost(this.pct, boost);
            if(!! boostWithOneMoreService ){
                const pctWithOneMoreService = this.calculateBoost(pctWithoutBoost, boostWithOneMoreService);
                this.deltaPctWithOneMoreService = pctWithOneMoreService - this.pct;
            }
        } else {
            this.deltaPctWithOneMoreService = 0;
        }

    }

    calculateBoost(basePct:number, boostValue:number) {
        return basePct * (1 + boostValue);
    }
}
